/*
 * faq-tabs.js
 * ---------------------------------------------------------------------------
 * Controller for <faq-tabs> (sections/faq-tabs.liquid). Two axes:
 *   1. Category tabs (.faq-tabs__cat) switch which .faq-tabs__panel is shown.
 *   2. A product-filter pill row (.faq-tabs__prod), built here per panel, filters
 *      that category's <details> items by their data-prod tag. The row is only
 *      injected for categories that actually contain product-specific questions.
 * Progressive enhancement: all content is server-rendered; JS only toggles
 * visibility + wires ARIA. Without JS the first category shows unfiltered.
 * ---------------------------------------------------------------------------
 */
(function () {
  var PRODS = ['bamboo-tp', 'tissue', 'trial']; // pill order after General

  function labelFor(root, prod) {
    return root.getAttribute('data-label-' + prod) || prod;
  }

  function filterItems(items, prod) {
    items.forEach(function (it) {
      var ip = it.dataset.prod || 'general';
      var show = prod === 'general' ? ip === 'general' : ip === prod;
      it.hidden = !show;
      if (!show) it.removeAttribute('open');
    });
  }

  function buildProductFilter(root, panel) {
    var items = Array.prototype.slice.call(panel.querySelectorAll('.faq-tabs__item'));
    var present = PRODS.filter(function (pr) {
      return items.some(function (it) { return it.dataset.prod === pr; });
    });
    if (!present.length) return; // all-general category → no filter row

    var hasGeneral = items.some(function (it) { return (it.dataset.prod || 'general') === 'general'; });
    var buckets = (hasGeneral ? ['general'] : []).concat(present);

    var bar = document.createElement('div');
    bar.className = 'faq-tabs__prod';
    bar.setAttribute('role', 'tablist');
    bar.setAttribute('aria-label', 'Filter by product');

    buckets.forEach(function (pr, idx) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'faq-tabs__prod-pill' + (idx === 0 ? ' is-active' : '');
      b.textContent = labelFor(root, pr);
      b.dataset.prod = pr;
      b.addEventListener('click', function () {
        bar.querySelectorAll('.faq-tabs__prod-pill').forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        filterItems(items, pr);
      });
      bar.appendChild(b);
    });

    panel.insertBefore(bar, panel.querySelector('.faq-tabs__list'));
    filterItems(items, buckets[0]);
  }

  function initTabs(root) {
    if (root.dataset.faqInit) return;
    root.dataset.faqInit = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('.faq-tabs__cat'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.faq-tabs__panel'));

    function selectCat(idx) {
      tabs.forEach(function (t) {
        var on = t.dataset.cat === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) { p.hidden = p.dataset.cat !== idx; });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { selectCat(t.dataset.cat); });
      t.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(t), n;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else return;
        e.preventDefault();
        tabs[n].focus();
        selectCat(tabs[n].dataset.cat);
      });
    });

    panels.forEach(function (p) { buildProductFilter(root, p); });

    /* Deep links (#faq-<handleized question>, emitted by faq-tabs.liquid and
       built by the contact page's "Fastest answers" rail): activate the item's
       category tab + product pill, open it, and scroll it into view. */
    function openFromHash() {
      var id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch (e) { return; }
      if (!id || id.indexOf('faq-') !== 0) return;
      var item = document.getElementById(id);
      if (!item || !root.contains(item) || !item.classList.contains('faq-tabs__item')) return;
      var panel = item.closest('.faq-tabs__panel');
      if (!panel) return;
      selectCat(panel.dataset.cat);
      if (item.hidden) {
        var pill = panel.querySelector('.faq-tabs__prod-pill[data-prod="' + (item.dataset.prod || 'general') + '"]');
        if (pill) pill.click();
      }
      item.open = true;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      item.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
    }
    openFromHash();
    window.addEventListener('hashchange', openFromHash);
  }

  function initAll() {
    document.querySelectorAll('faq-tabs').forEach(initTabs);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
